/* unplugin-vue-components disabled */import script from "./DiagnosePopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./DiagnosePopup.vue?vue&type=script&setup=true&lang=ts"

import "./DiagnosePopup.vue?vue&type=style&index=0&id=4c1e9022&lang=less&scoped=true"

import exportComponent from "/layers/paketo-buildpacks_npm-install/build-modules/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c1e9022"]])

export default __exports__